const defaultMenuLinks = [
    {
        text: '',
        href: '',
        noindex: false,
        nofollow: false,
        noReferrer: false,
        isTextVisible: false,
        isLink: false,
        children: [
            {
                text: 'О компании',
                href: '/about/o-kompanii/',
                noindex: true,
                nofollow: true,
                isTextVisible: true,
                isLink: true,
                children: [],
                noReferrer: false
            },
            {
                text: 'Контакты',
                href: '/about/kontakty/',
                noindex: true,
                nofollow: true,
                isTextVisible: true,
                isLink: true,
                children: [],
                noReferrer: false
            },
            {
                text: 'Партнерская программа',
                href: 'https://partner2.sravni.ru/',
                noindex: true,
                nofollow: true,
                isTextVisible: true,
                isLink: true,
                children: [],
                noReferrer: false
            },
            {
                text: 'Для агентов',
                href: 'https://sravni-labs.ru/start/',
                noindex: false,
                nofollow: false,
                isTextVisible: true,
                isLink: true,
                children: [],
                noReferrer: false
            },
            {
                text: 'Пользовательское соглашение',
                href: '/promo/polzovatelskoe-soglashenie/',
                noindex: true,
                nofollow: true,
                isTextVisible: true,
                isLink: true,
                children: [],
                noReferrer: false
            },
            {
                text: 'Политика конфиденциальности',
                href: '/about/privacy-policy/',
                noindex: true,
                nofollow: true,
                isTextVisible: true,
                isLink: true,
                children: [],
                noReferrer: false
            },
            {
                text: 'Энциклопедия',
                href: '/enciklopediya/',
                noindex: false,
                nofollow: false,
                isTextVisible: true,
                isLink: true,
                children: [],
                noReferrer: false
            },
            {
                text: 'Карта сайта',
                href: '/karta-sajta/',
                noindex: false,
                nofollow: false,
                isTextVisible: true,
                isLink: true,
                children: [],
                noReferrer: false
            },
            {
                text: 'Наши эксперты',
                href: 'https://www.sravni.ru/u/rating/',
                noindex: false,
                nofollow: false,
                isTextVisible: true,
                isLink: true,
                children: [],
                noReferrer: false
            },
            {
                text: 'Наши вакансии',
                href: 'https://hh.ru/employer/560786',
                noindex: false,
                nofollow: false,
                isTextVisible: true,
                isLink: true,
                children: [],
                noReferrer: false
            },
        ],
    },
];

export { defaultMenuLinks };
//# sourceMappingURL=menuLinks.js.map
